export const RESPONSES_TYPE_COLOR = {
  Self: '#4dabf7',
  'Self Assessment': '#4dabf7',
  Peer: '#40c057',
  'Peer Assessment': '#40c057',
  Supervisor: '#7950f2',
  Subordinate: '#fd7e14'
};
